import React from "react";
import { User } from "@common/types/user";
import { UserAvatar } from "@components/avatar/UserAvatar";
import styles from "./WorkspaceMembers.module.scss";

interface Props {
    user: User;
}

export const MemberCard: React.FC<Props> = ({ user }) => (
    <div className={styles.card}>
        <UserAvatar user={user} size="md" aria-hidden />
        <div>
            <div>{user.name}</div>
            <small className="text-grey">{user.email}</small>
        </div>
    </div>
);
